/**
 * @desc 财务画像-财务风险分析-风险点汇总
 * @author caoyx
 */

import styles from './summary.scss';
import React, { PureComponent } from 'react';
import { Table, Spin } from 'antd';
import GroupBox from '../../../common/groupBox/GroupBox';
import { getCombineIndexColumns } from '../../common/commons';

export default class Summary extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            //
        };
    }

    createKey = (d) => {
        return d.abnormalType + d.abnormalValue;
    };

    render() {
        const { loading, data } = this.props;
        const { financeAbnormalAnalysisSummaryDtoList = []} = data;
        // const { industry, assetScale, assetStructure, financeAbnormalAnalysisSummaryDtoList = []} = this.props.finacialPortraitRiskStaticsVO;

        return (
            <GroupBox id="risk-summary" title="财务风险点提示">
                {
                    loading ?
                        <Spin /> :
                        <div>
                            <ul className={styles.summaryTop}>
                                {/* <li>
                                <div className={classNames(styles.textBox, styles.industry)}>
                                    <div className={styles.text}>
                                        <p>行业：{fieldAnomaly(industry)}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className={classNames(styles.textBox, styles.assets)}>
                                    <div className={styles.text}>
                                        <p>资产规模：{fieldAnomaly(assetScale)}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className={classNames(styles.textBox, styles.structure)}>
                                    <div className={styles.text}>
                                        <p>资产结构：{fieldAnomaly(assetStructure)}</p>
                                    </div>
                                </div>
                            </li> */}
                            </ul>
                            <div>
                                <Table
                                    bordered
                                    rowKey={this.createKey}
                                    className="table-margin"
                                    dataSource={financeAbnormalAnalysisSummaryDtoList}
                                    columns={getCombineIndexColumns(financeAbnormalAnalysisSummaryDtoList)}
                                    pagination={false}
                                />
                            </div>
                        </div>
                }
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/Summary.jsx